"use strict";
//  Copyright 2018, Venkat Peri.
//
//  Permission is hereby granted, free of charge, to any person obtaining a
//  copy of this software and associated documentation files (the
//  "Software"), to deal in the Software without restriction, including
//  without limitation the rights to use, copy, modify, merge, publish,
//  distribute, sublicense, and/or sell copies of the Software, and to permit
//  persons to whom the Software is furnished to do so, subject to the
//  following conditions:
//
//  The above copyright notice and this permission notice shall be included
//  in all copies or substantial portions of the Software.
//
//  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
//  OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
//  MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
//  NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
//  DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
//  OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
//  USE OR OTHER DEALINGS IN THE SOFTWARE.
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Emittery = require('emittery');
var pTimeout = require("p-timeout");
var Route = require("route-parser");
var action_1 = require("./action");
var Context_1 = require("./Context");
var event_1 = require("./event");
var EnterEvent_1 = require("./event/EnterEvent");
var Logger_1 = require("./Logger");
var result_1 = require("./result");
var builder_1 = require("./result/builder");
var State_1 = require("./State");
var types_1 = require("./types");
require("./util/ArrayHelpers");
var delay_1 = require("./util/delay");
var Pending_1 = require("./util/Pending");
var Timers_1 = require("./util/Timers");
var StablePriorityQueue = require("stablepriorityqueue");
/**
 * @hidden
 */
var Log = Logger_1.default("StateMachine");
/**
 * State Machine
 */
var StateMachine = /** @class */ (function () {
    /**
     * Creates a StateMachine
     * @param init - initialization options
     */
    function StateMachine(init) {
        /**
         * @hidden
         * @type {undefined}
         */
        this.handlers = undefined;
        /**
         *
         * @hidden
         * @type {undefined}
         */
        this.initialData = undefined;
        /**
         * @hidden
         *
         * @type {undefined}
         */
        this.initialState = undefined;
        /**
         * @hidden
         */
        this.log = {
            d: this.logger("d"),
            e: this.logger("e"),
            i: this.logger("i"),
            v: this.logger("v"),
            w: this.logger("w"),
        };
        /**
         * Built in handlers. Appended to the end.
         *
         * @type {Handlers}
         */
        this.defaultHandlers = [
            // Get the current state & data
            ["call/:from#getStateAndData#*_",
                function (_a) {
                    var args = _a.args, current = _a.current, data = _a.data;
                    return builder_1.reply(args.from, [current, data]);
                }]
        ];
        this._current = new Context_1.Context();
        this._emitter = new Emittery();
        this._next = new Context_1.Context();
        this._pending = new Pending_1.default();
        this._routeHandlers = [];
        this._started = false;
        this._stopped = false;
        this.events = new StablePriorityQueue(event_1.default.comparator);
        this.isInitialState = true;
        this.postponedEvents = [];
        this.processingEvent = false;
        this.timers = new Timers_1.default();
        // super();
        Object.assign(this, init);
        this.animation = this.animation || {};
    }
    Object.defineProperty(StateMachine.prototype, "isRunning", {
        /**
         *
         * @return {boolean}
         */
        get: function () {
            return this._started && !this._stopped;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateMachine.prototype, "data", {
        /**
         * Gets the current data. Internal use only.
         *
         */
        get: function () {
            if (this.dataProxy) {
                return this.dataProxy.get();
            }
            return this._current.data;
        },
        /**
         * Sets the current {Data}. Internal only.
         * @param value the {Data}
         */
        set: function (value) {
            this._next.data = Object.freeze(value);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateMachine.prototype, "state", {
        /**
         * Gets the current state. Internal use only.
         * Use getState() to query state safely.
         *
         * @return {State}
         */
        get: function () {
            return this._current.state;
        },
        /**
         * Sets the current state. Internal use only.
         * @param s
         */
        set: function (s) {
            this.doSetState(s);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateMachine.prototype, "usingDefaultHandler", {
        get: function () {
            return this._current.usingDefaultHandler;
        },
        set: function (v) {
            this._next.usingDefaultHandler = v;
        },
        enumerable: true,
        configurable: true
    });
    /**
     * @hidden
     * add an event handler
     *
     * @param routes
     * @param handler
     * @return {this<{TData}>}
     */
    StateMachine.prototype.addHandler = function (routes, handler) {
        if (this._started) {
            throw new Error("Can't add handler. Already running.");
        }
        this.log.v("addHandler", routes, handler);
        if (typeof routes === "string") {
            routes = [routes];
        }
        try {
            var mapped = routes.map(function (r) { return [r, new Route(r)]; });
            this._routeHandlers.push({ routes: mapped, handler: handler });
        }
        catch (e) {
            Log.e(e, routes || "No route!");
            throw e;
        }
        return this;
    };
    /**
     * @hidden
     * @param request
     * @param extra
     * @return {Promise<any>}
     */
    StateMachine.prototype.call = function (request, extra) {
        return __awaiter(this, void 0, void 0, function () {
            var from;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        from = this._pending.create();
                        this.log.i("call", request, from);
                        this.addEvent(new event_1.CallEvent(from, request, extra));
                        return [4 /*yield*/, this._pending.get(from)];
                    case 1: return [2 /*return*/, _a.sent()];
                }
            });
        });
    };
    /**
     * @hidden
     *
     * @param request
     * @param extra
     */
    StateMachine.prototype.cast = function (request, extra) {
        this.log.i("cast", request);
        this.addEvent(new event_1.CastEvent(request, extra));
    };
    /**
     *
     * @hidden
     * @param event
     * @param args
     * @param current
     * @param data
     * @return {undefined}
     */
    StateMachine.prototype.defaultEventHandler = function (_a) {
        var event = _a.event, args = _a.args, current = _a.current, data = _a.data;
        this.log.i("defaultHandler", event.toString(), args);
        return undefined;
    };
    /**
     * @hidden
     * Returns the current data after any already enqueued events are
     * processed
     *
     * @return {Promise<[State , TData][1]>}
     */
    StateMachine.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStateAndData()];
                    case 1: return [2 /*return*/, (_a.sent())[1]];
                }
            });
        });
    };
    /**
     * @hidden
     * Returns the current state after any already enqueued events
     * are processed
     *
     * @return {Promise<any>}
     */
    StateMachine.prototype.getState = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.getStateAndData()];
                    case 1: return [2 /*return*/, (_a.sent())[0]];
                }
            });
        });
    };
    /**
     * @hidden
     * @return {Promise<[State , TData]>}
     */
    StateMachine.prototype.getStateAndData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                return [2 /*return*/, this.call("getStateAndData")];
            });
        });
    };
    Object.defineProperty(StateMachine.prototype, "hasEventTimer", {
        /**
         *
         * @hidden
         * @return {boolean}
         */
        get: function () {
            return this.hasTimer("eventTimeout");
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(StateMachine.prototype, "hasStateTimer", {
        /**
         * @hidden
         *
         * @return {boolean}
         */
        get: function () {
            return this.hasTimer("stateTimeout");
        },
        enumerable: true,
        configurable: true
    });
    /**
     *
     * @hidden
     * @param name
     * @return {boolean}
     */
    StateMachine.prototype.hasTimer = function (name) {
        return !!this.timers.get(name);
    };
    /**
     * @hidden
     * Starts the state machine
     * @return {this<TData>}
     */
    StateMachine.prototype.startSM = function () {
        var _this = this;
        if (this._started) {
            return this;
        }
        this.log.i("startSM");
        this.timers
            .on('createTimer', function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.emit('createTimer', args);
        })
            .on('cancelTimer', function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this.emit('cancelTimer', args);
        });
        if (!this.initialState) {
            throw new Error("Initial state must be defined");
        }
        if (this.initialData) {
            this.data =
                typeof this.initialData === 'function'
                    ? this.initialData()
                    : this.initialData;
        }
        this.initHandlers();
        this._started = true;
        this.state = this.initialState;
        this.switchContext();
        this.emit("init");
        this.processEvents();
        return this;
    };
    /**
     * @hidden
     * stop the state machine
     *
     * @param reason
     * @param data
     */
    StateMachine.prototype.stopSM = function (reason, data) {
        if (!this.isRunning) {
            throw new Error("Can't stop. Illegal state.");
        }
        this.log.i("stop: " + reason);
        this._stopped = true;
        this.emit("terminate", reason);
    };
    /**
     * Trigger an event asynchronously, optionally with some data. Listeners
     * are called in the order they were added, but execute concurrently.
     *
     * Returns a promise for when all the event listeners are done. Done
     * meaning executed if synchronous or resolved when an
     * async/promise-returning function. You usually wouldn't want to wait for
     * this, but you could for example catch possible errors. If any of the
     * listeners throw/reject, the returned promise will be rejected with the
     * error, but the other listeners will not be affected.
     *
     * @param name
     * @param args
     * @return {Promise<void>}
     */
    StateMachine.prototype.emit = function (name) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return this._emitter.emit(name, args);
    };
    /**
     * Subscribe to an event.
     * @param name
     * @param cb
     * @return {this<TData>}
     */
    StateMachine.prototype.on = function (name, cb) {
        this._emitter.on(name, function (a) {
            if (Array.isArray(a)) {
                return cb.apply(void 0, a);
            }
            cb(a);
        });
        return this;
    };
    /**
     *
     * @param time
     * @return {any}
     */
    StateMachine.prototype.doSetEventTimeout = function (time) {
        this.log.i("setEventTimeout", time);
        if (time < 0) {
            return this.cancelTimer('eventTimeout');
        }
        var that = this;
        this.setTimer(time, "eventTimeout")
            .on("timer", function () { return that.addEvent(new event_1.EventTimeoutEvent({ time: time }), { internal: true }); });
        return this;
    };
    /**
     *
     * @param time
     * @param name
     * @return {any}
     */
    StateMachine.prototype.doSetGenericTimeout = function (time, name) {
        if (name === void 0) { name = "DEFAULT"; }
        this.log.i("setEventTimeout", name, time);
        if (time < 0) {
            return this.cancelTimer(name);
        }
        var that = this;
        this.setTimer(time, name)
            .on("timer", function () {
            return that.addEvent(new event_1.GenericTimeoutEvent({ name: name, time: time }), { internal: true });
        });
    };
    /**
     * Get route handler for given event
     * @param e
     * @return {MatchedHandler|undefined}
     */
    StateMachine.prototype.getEventHandler = function (e) {
        var eventRoute = e.toRoute(this.state);
        this.log.i("getEventHandler", String(e), eventRoute);
        var index = 0;
        for (var _i = 0, _a = this._routeHandlers; _i < _a.length; _i++) {
            var routeHandler = _a[_i];
            for (var _b = 0, _c = routeHandler.routes; _b < _c.length; _b++) {
                var route = _c[_b];
                var result = route[1].match(eventRoute);
                if (result) {
                    return {
                        index: index, result: result,
                        route: route[0],
                        routeHandler: routeHandler.handler,
                    };
                }
            }
            index++;
        }
        return undefined;
    };
    /**
     *
     * @param action
     * @param event
     */
    StateMachine.prototype.handleAction = function (action, event) {
        this.log.i("handleAction", action.toString());
        if (action_1.isEmitAction(action)) {
            this._next.emit.push([action.name, action.args]);
        }
        else if (action_1.isReplyAction(action)) {
            this._next.replies.push([action.from, action.reply]);
        }
        else if (action_1.isStateTimeoutAction(action)) {
            this.setStateTimeout(action.time);
        }
        else if (action_1.isEventTimeoutAction(action)) {
            this.setEventTimeout(action.time);
        }
        else if (action_1.isGenericTimeoutAction(action)) {
            this.setGenericTimeout(action.time, action.name);
        }
        else if (action_1.isNextEventAction(action)) {
            this.addNextEvent(action);
        }
        else if (action_1.isPostponeAction(action)) {
            event.priority -= 20; // boost priority to ensure this is queued
            // first
            this.postponedEvents.push(event);
            this.log.i('postponed', this.postponedEvents);
        }
        else {
            throw new Error("No handler for action: " + action);
        }
    };
    /**
     * Handle the given event. Matches the event's route to the
     * @param event
     * @return {Promise<void>}
     */
    StateMachine.prototype.handleEvent = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var h, handlerOpts, result, res;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.processingEvent = true;
                        h = this.getEventHandler(event);
                        this.emit('currentEvent', event);
                        handlerOpts = {
                            args: h ? h.result : {},
                            current: this.state,
                            data: this.data,
                            event: event,
                            route: h ? h.route : ''
                        };
                        this.log.i("handleEvent", event.type, { args: handlerOpts.args, route: handlerOpts.route });
                        result = this.invokeHandler(h && h.routeHandler, handlerOpts);
                        res = this.handleResult(result, event);
                        res = this.handlerTimeout ? pTimeout(res, this.handlerTimeout) : res;
                        return [4 /*yield*/, res];
                    case 1:
                        _a.sent();
                        this.switchContext(event, h ? h.index : -1);
                        if (!(this.animation && this.animation.delay &&
                            (this.animation.includeDefault || !this.usingDefaultHandler))) return [3 /*break*/, 3];
                        return [4 /*yield*/, delay_1.default(this.animation.delay)];
                    case 2:
                        _a.sent();
                        _a.label = 3;
                    case 3:
                        this.processingEvent = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Process event handler result
     * @param r
     * @param event
     * @return {Promise<void>}
     */
    StateMachine.prototype.handleResult = function (r, event) {
        return __awaiter(this, void 0, void 0, function () {
            var res, _i, _a, a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, r];
                    case 1:
                        r = (_b.sent()) || builder_1.keepState();
                        res = result_1.isResultBuilder(r) ? r.getResult(this.data) : r;
                        this.log.i("handleResult", res);
                        for (_i = 0, _a = res.actions; _i < _a.length; _i++) {
                            a = _a[_i];
                            this.handleAction(a, event);
                        }
                        if (result_1.isNextStateResult(res)) {
                            this.state = res.nextState;
                        }
                        else if (result_1.isKeepStateResult(res)) {
                            this.state = this.state;
                        }
                        else if (result_1.isRepeatStateResult(res)) {
                            this.doSetState(this.state, true);
                        }
                        if (result_1.isResultWithData(res) && res.hasData) {
                            this.data = res.newData;
                        }
                        else {
                            this.data = this.data;
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Initialize handlers,
     * Default handlers come last
     */
    StateMachine.prototype.initHandlers = function () {
        var handlers = this.defaultHandlers.concat(this.handlers || []);
        for (var _i = 0, handlers_1 = handlers; _i < handlers_1.length; _i++) {
            var h = handlers_1[_i];
            if (Array.isArray(h)) {
                this.addHandler(h[0], h[1]);
            }
            else {
                for (var _a = 0, _b = Object.entries(h); _a < _b.length; _a++) {
                    var _c = _b[_a], k = _c[0], v = _c[1];
                    this.addHandler(k, v);
                }
            }
        }
    };
    /**
     * @hidden
     * Adds state to log tags
     * @param level
     * @return {(tag2: string, ...args: any[]) => void}
     */
    StateMachine.prototype.logger = function (level) {
        var _this = this;
        return function (tag2) {
            var args = [];
            for (var _i = 1; _i < arguments.length; _i++) {
                args[_i - 1] = arguments[_i];
            }
            Log[level].apply(Log, [tag2 + "@" + State_1.stateRoute(_this.state) + ": "].concat(args));
        };
    };
    /**
     * Starts the event timeout timer.
     *
     * If an event arrives before the timer fires, the timer
     * is cancelled. You get either an event or a time-out,
     * but not both.
     *
     * @param time the timeout
     * @return {this}
     */
    StateMachine.prototype.setEventTimeout = function (time) {
        this._next.eventTimeout = time;
    };
    /**
     * Starts a generic timeout timer with an optional name.
     *
     * @param time the timeout in ms
     * @param name optional name. Defaults to "DEFAULT"
     */
    StateMachine.prototype.setGenericTimeout = function (time, name) {
        if (name === void 0) { name = "DEFAULT"; }
        this._next.genericTimeout = [time, name];
    };
    /**
     * Add event to the queue. Emits the 'event' event
     *
     * @param event
     * @return {this}
     * @param internal - if true, event was internally generated
     * @param noProcess
     */
    StateMachine.prototype.addEvent = function (event, _a) {
        var _b = _a === void 0 ? {} : _a, noProcess = _b.noProcess, internal = _b.internal;
        if (!this.isRunning) {
            throw new Error("Can't add event. Not running.");
        }
        this.log.i("addEvent", event.toString(), internal, noProcess);
        if (!internal) {
            this.cancelTimer('eventTimeout');
        }
        this.events.add(event);
        this.emit("event", event);
        if (!noProcess) {
            this.processEvents();
        }
    };
    /**
     * Add an event as the *next* event
     * @param action
     */
    StateMachine.prototype.addNextEvent = function (action) {
        var event = event_1.makeNextEvent(action);
        if (event) {
            event.priority = types_1.Priority.Highest;
            this._next.nextEvents.push(event);
        }
    };
    /**
     * Cancels the named timer
     *
     * @param name
     * @return {this}
     */
    StateMachine.prototype.cancelTimer = function (name) {
        this.timers.cancel(name);
    };
    /**
     * Actually process events
     */
    StateMachine.prototype.doProcessEvents = function () {
        var _this = this;
        if (!this.isRunning
            || this.events.isEmpty()
            || this.processingEvent) {
            return;
        }
        this.log.v("processEvents", this.events);
        var e = this.events.poll();
        if (e) {
            this.handleEvent(e)
                .then(function () { return _this.processEvents(); })
                .catch(function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return _this.emit.apply(_this, ['error'].concat(args));
            });
        }
    };
    /**
     *
     * @param s
     * @param entered
     */
    StateMachine.prototype.doSetState = function (s, entered) {
        if (entered === void 0) { entered = false; }
        if (State_1.isStringState(s) && s.indexOf('/') > 0) {
            s = s.split('/');
        }
        this._next.state = s;
        this._next.enterState = entered;
    };
    /**
     *
     * @param time
     */
    StateMachine.prototype.doSetStateTimeout = function (time) {
        this.log.i("setStateTimeout", time);
        if (time < 0) {
            return this.cancelTimer('stateTimeout');
        }
        var that = this;
        this.setTimer(time, "stateTimeout")
            .on("timer", function () { return that.addEvent(new event_1.StateTimeoutEvent({ time: time }), { internal: true }); });
    };
    /**
     * Executes handler and returns result
     * @param opts
     * @param handler
     * @return {any}
     */
    StateMachine.prototype.invokeHandler = function (handler, opts) {
        this.log.i('invokeHandler', handler, opts);
        if (typeof handler === "function") {
            return handler.call(this, opts);
        }
        if (typeof handler === 'string') {
            return builder_1.nextState(handler);
        }
        if (Array.isArray(handler)) {
            return builder_1.nextState(handler[0]).eventTimeout(handler[1]);
        }
        this.usingDefaultHandler = true;
        return this.defaultEventHandler(opts);
    };
    /**
     * Process the next event on the event queue
     */
    StateMachine.prototype.processEvents = function () {
        setImmediate(this.doProcessEvents.bind(this));
    };
    /**
     *
     */
    StateMachine.prototype.sendPostponedEvents = function () {
        for (var _i = 0, _a = this.postponedEvents; _i < _a.length; _i++) {
            var e = _a[_i];
            this.addEvent(e);
        }
        this.postponedEvents = [];
    };
    /**
     * Starts the state timeout timer
     *
     * The timer for a state time-out is automatically cancelled when
     * the state machine changes states. You can restart a state
     * time-out by setting it to a new time, which cancels the
     * running timer and starts a new.
     *
     * @param time the timeout in ms
     */
    StateMachine.prototype.setStateTimeout = function (time) {
        this._next.stateTimeout = time;
    };
    /**
     * Sets a named timer
     * @param name
     * @param time
     * @return {Timer}
     */
    StateMachine.prototype.setTimer = function (time, name) {
        return this.timers.create(time, name);
    };
    /**
     *
     * @param event
     * @param handlerIndex
     */
    StateMachine.prototype.switchContext = function (event, handlerIndex) {
        if (handlerIndex === void 0) { handlerIndex = -1; }
        var _a;
        this.log.i('switchContext');
        var prev = this.isInitialState ? this._next : this._current;
        var current = this._current = this._next;
        var stateChanged = this.isInitialState
            || current.enterState
            || !current.stateEq(prev);
        this.isInitialState = false;
        if (stateChanged) {
            this.cancelTimer('stateTimeout');
        }
        for (var _i = 0, _b = current.replies; _i < _b.length; _i++) {
            var reply_1 = _b[_i];
            (_a = this._pending).resolve.apply(_a, reply_1);
        }
        for (var _c = 0, _d = current.nextEvents; _c < _d.length; _c++) {
            var event_2 = _d[_c];
            this.addEvent(event_2, { noProcess: true, internal: true });
        }
        if (stateChanged) {
            this.addEvent(new EnterEvent_1.default({ old: prev.stateName }), { internal: true, noProcess: true });
            this.sendPostponedEvents();
        }
        if (current.stateTimeout) {
            this.doSetStateTimeout(current.stateTimeout);
        }
        if (current.eventTimeout) {
            this.doSetEventTimeout(current.eventTimeout);
        }
        if (current.genericTimeout) {
            this.doSetGenericTimeout.apply(this, current.genericTimeout);
        }
        var args = [current.state, prev.state,
            current.data, event, handlerIndex];
        var events = this._next.emit;
        events.unshift(['state', args]);
        if (stateChanged) {
            events.unshift(['stateChanged', args]);
        }
        if (this.dataProxy) {
            this.dataProxy.set(current.data, current.state);
        }
        this._next = new Context_1.Context(this.state);
        for (var _e = 0, events_1 = events; _e < events_1.length; _e++) {
            var e = events_1[_e];
            this.emit.apply(this, [e[0]].concat(e[1]));
        }
    };
    return StateMachine;
}());
exports.StateMachine = StateMachine;
//# sourceMappingURL=StateMachine.js.map